export default __webpack_public_path__ + "static/seattle.skyline.3-137ed84f72a71491b8c4d7fa1a6cebae.svg";